'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["config"];
import curry from 'transmute/curry';
import { ReportConfigType } from 'reporting-ui-components/types/ReportTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export function Label(Component) {
  function wrapped({
    config,
    use,
    report
  }) {
    return /*#__PURE__*/_jsx(Component, {
      config: config,
      use: use,
      report: report
    });
  }
  wrapped.displayName = 'Label';
  wrapped.propTypes = {
    config: ReportConfigType.isRequired
  };
  return wrapped;
}
export const ConditionalLabel = curry((condition, Component) => {
  function wrapped(_ref) {
    let {
        config
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return condition({
      config
    }) ? /*#__PURE__*/_jsx(Component, Object.assign({
      config: config
    }, rest)) : null;
  }
  wrapped.displayName = 'ConditionalLabel';
  wrapped.propTypes = {
    config: ReportConfigType.isRequired
  };
  return wrapped;
});